import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import { IQueueExecutionCustomCalculationsProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import SchemaGenerator from "./SchemaGenerator";
import { CalculationFieldType } from "@/components/CustomCalculations/models/CalculationFieldType";


export class CustomCalculationSchemaGenerator extends SchemaGenerator<IQueueExecutionCustomCalculationsProp> {

    public createRootSchema(): JsonEditorSchema<IQueueExecutionCustomCalculationsProp> {

        const rootSchema: JsonEditorSchema<IQueueExecutionCustomCalculationsProp> = {
            type: 'object',
            additionalProperties: false,
            properties: {
                output: {
                    type: 'object',
                    additionalProperties: true,
                    properties: {
                        sort: {
                            type: 'array', items: {
                                type: 'string'
                            }
                        }
                    },
                    required: ['sort']
                },
                calculations: {
                    type: 'array',
                    items: {
                        type: 'object',
                        additionalProperties: true,
                        properties: {
                            type: { type: 'string' }
                        },
                        required: ["type"]
                    }
                }
            },
            required: ['output', 'calculations'],
        };

        return rootSchema;
    }

    public mapType(fieldType: any): JsonEditorType | null {
        switch (fieldType) {
            case CalculationFieldType.Text:
            case CalculationFieldType.Select:
            case CalculationFieldType.SelectOrCreate:
            case CalculationFieldType.ColumnSelectOrCreate:
            case CalculationFieldType.ColumnSelect:
            case CalculationFieldType.SelectJson:
            case CalculationFieldType.ColorPicker:
            case CalculationFieldType.StringTemplate:
            case CalculationFieldType.RegularExpression:
            case CalculationFieldType.ParamSelect:
            case CalculationFieldType.ParamSelectOrCreate:
                return 'string';
            case CalculationFieldType.Number:
                return 'number';
            case CalculationFieldType.Boolean:
                return 'boolean';
            case CalculationFieldType.Array:
            case CalculationFieldType.ArrayValues:
            case CalculationFieldType.MultiSelect:
            case CalculationFieldType.ColumnMultiSelect:
            case CalculationFieldType.ColumnMultiSelectOrCreate:
            case CalculationFieldType.ParamMultiSelect:
            case CalculationFieldType.ParamMultiSelectOrCreate:
                return 'array';
            case CalculationFieldType.Object:
            case CalculationFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public populateVariants(schema: JsonEditorSchema<IQueueExecutionCustomCalculationsProp>, variants: Array<any>, options: any): void {

        schema.properties.calculations!.items = {
            type: 'object',
            additionalProperties: options.additionalProperties,
            required: ['type'],
            allOf: variants.map((variant: any) => {
                const { type: _t, ...otherProps } = variant.properties;
                const typeValue = variant.properties.type?.enum?.[0];
                return {
                    if: {
                        properties: { type: { const: typeValue } },
                        required: ['type']
                    },
                    then: {
                        properties: otherProps,
                        ...(variant.required?.length > 1
                            ? { required: variant.required }
                            : {})
                    }
                };
            })
        };

    }
}

export default CustomCalculationSchemaGenerator;
